import actions from './actions';
import authActions from '../auth/actions';

const initState = {
  quotations: [],
  templates: [],
  quotationTags: [],
  currentQuotation: null,
  executingQuotation: null,
  loading: false,
  saving: false,
  savingTemplate: false,
  savingTag: false,
  publicQuotation: null,
  publicLoading: false,
  quotationLogs: [],
  logsLoading: false,
  quotationComments: [],
  commentsLoading: false,
  savingComment: false,
  allQuotationComments: [],
  quotationStatusNotifications: [],
  userMentions: [],
};

export default function quotationReducer(state = initState, action) {
  switch (action.type) {
    case authActions.CLEAR_STATES:
      return { ...initState };

    case actions.FETCHING_QUOTATIONS:
      return { ...state, loading: true };
    case actions.FETCH_QUOTATIONS_SUCCESS:
      return {
        ...state,
        quotations: action.payload,
        loading: false,
      };
    case actions.FETCH_QUOTATIONS_ERROR:
      return { ...state, quotations: [], loading: false };

    case actions.SAVING_QUOTATION:
      return { ...state, saving: true };
    case actions.SAVE_QUOTATION_SUCCESS:
      return { ...state, saving: false, currentQuotation: null };
    case actions.SAVE_QUOTATION_ERROR:
      return { ...state, saving: null };

    case actions.DELETE_QUOTATION_SUCCESS:
      return { ...state };
    case actions.DELETE_QUOTATION_ERROR:
      return { ...state };

    case actions.UPDATE_QUOTATION_STATUS_SUCCESS:
      return { ...state };
    case actions.UPDATE_QUOTATION_STATUS_ERROR:
      return { ...state };

    case actions.FETCH_TEMPLATES_SUCCESS:
      return { ...state, templates: action.payload };
    case actions.FETCH_TEMPLATES_ERROR:
      return { ...state, templates: [] };

    case actions.SAVING_TEMPLATE:
      return { ...state, savingTemplate: true };
    case actions.SAVE_TEMPLATE_SUCCESS:
      return { ...state, savingTemplate: false };
    case actions.SAVE_TEMPLATE_ERROR:
      return { ...state, savingTemplate: null };

    case actions.DELETE_TEMPLATE_SUCCESS:
      return { ...state };
    case actions.DELETE_TEMPLATE_ERROR:
      return { ...state };

    case actions.FETCHING_PUBLIC_QUOTATION:
      return { ...state, publicLoading: true };
    case actions.FETCH_PUBLIC_QUOTATION_SUCCESS:
      return {
        ...state,
        publicQuotation: action.payload,
        publicLoading: false,
      };
    case actions.FETCH_PUBLIC_QUOTATION_ERROR:
      return { ...state, publicQuotation: null, publicLoading: false };

    case actions.SEND_WHATSAPP_SUCCESS:
      return { ...state };
    case actions.SEND_WHATSAPP_ERROR:
      return { ...state };

    case actions.FETCH_QUOTATION_TAGS_SUCCESS:
      return { ...state, quotationTags: action.payload };
    case actions.FETCH_QUOTATION_TAGS_ERROR:
      return { ...state, quotationTags: [] };

    case actions.SAVING_QUOTATION_TAG:
      return { ...state, savingTag: true };
    case actions.SAVE_QUOTATION_TAG_SUCCESS:
      return { ...state, savingTag: false };
    case actions.SAVE_QUOTATION_TAG_ERROR:
      return { ...state, savingTag: null };

    case actions.DELETE_QUOTATION_TAG_SUCCESS:
      return { ...state };
    case actions.DELETE_QUOTATION_TAG_ERROR:
      return { ...state };

    case actions.FETCHING_QUOTATION_LOGS:
      return { ...state, logsLoading: true };
    case actions.FETCH_QUOTATION_LOGS_SUCCESS:
      return { ...state, quotationLogs: action.payload, logsLoading: false };
    case actions.FETCH_QUOTATION_LOGS_ERROR:
      return { ...state, quotationLogs: [], logsLoading: false };

    case actions.SET_CURRENT_QUOTATION:
      return { ...state, currentQuotation: action.payload };
    case actions.CLEAR_CURRENT_QUOTATION:
      return { ...state, currentQuotation: null };

    case actions.SET_EXECUTING_QUOTATION:
      return { ...state, executingQuotation: action.payload };
    case actions.CLEAR_EXECUTING_QUOTATION:
      return { ...state, executingQuotation: null };
    case actions.EXECUTE_QUOTATION_SUCCESS:
      return { ...state, executingQuotation: null };
    case actions.EXECUTE_QUOTATION_ERROR:
      return { ...state };

    case actions.QUOTATION_COMMENTS_LISTENER_SUCCESS:
      return { ...state, allQuotationComments: action.payload };

    case actions.QUOTATION_STATUS_CHANGE:
      return {
        ...state,
        quotationStatusNotifications: [...state.quotationStatusNotifications, action.payload],
      };
    case actions.QUOTATION_STATUS_NOTIFICATION_DISMISS:
      return {
        ...state,
        quotationStatusNotifications: state.quotationStatusNotifications.filter(
          (q) => q.id !== action.payload,
        ),
      };

    case actions.USER_MENTION_RECEIVED:
      return {
        ...state,
        userMentions: [...state.userMentions, action.payload],
      };
    case actions.DISMISS_USER_MENTION_REQUEST:
      return {
        ...state,
        userMentions: state.userMentions.filter((m) => m.id !== action.payload),
      };

    case actions.FETCHING_QUOTATION_COMMENTS:
      return { ...state, commentsLoading: true };
    case actions.FETCH_QUOTATION_COMMENTS_SUCCESS:
      return { ...state, quotationComments: action.payload, commentsLoading: false };
    case actions.FETCH_QUOTATION_COMMENTS_ERROR:
      return { ...state, quotationComments: [], commentsLoading: false };

    case actions.SAVING_QUOTATION_COMMENT:
      return { ...state, savingComment: true };
    case actions.SAVE_QUOTATION_COMMENT_SUCCESS:
      return { ...state, savingComment: false };
    case actions.SAVE_QUOTATION_COMMENT_ERROR:
      return { ...state, savingComment: false };

    case actions.DELETE_QUOTATION_COMMENT_SUCCESS:
      return { ...state };
    case actions.DELETE_QUOTATION_COMMENT_ERROR:
      return { ...state };

    default:
      return state;
  }
}
